import type { ReactNode } from 'react';

interface Props {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, desc, action }: Props) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
      <div className="max-w-2xl">
        {eyebrow && (
          <span className="inline-flex items-center gap-2 text-xs font-label font-medium tracking-widest text-primary-700 mb-2">
            <span className="w-6 h-px bg-primary-500"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-tight">{title}</h2>
        {desc && <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed">{desc}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}